import { Injectable } from '@angular/core';

import { ConfigService, EntityService } from 'viggo-sistemas-core-web';

import { ICatalogo } from '@app/modules/catalogo-produto-components/model';

import {
  ICatalogoProdutoEquipeVenda,
  IEquipeVenda
} from '../../model/equipe-venda.model';

@Injectable()
export class EquipeVendaService extends EntityService<IEquipeVenda> {
  constructor(protected configService: ConfigService) {
    super({
      urlBackend: configService.backendURL,
      baseEntityEndPoint: 'equipe_venda'
    });
  }

  /**
   * Faz um diff entre os catalogos que já foram salvos no backend e
   * uma lista de repassado e remove/add com base na nova lista
   * @param catalogosJaSalvos catalogos que já estào salvos no backend
   * @param catalogosSelecionados catalogos que foram selecioandos
   */
  public separarCatalogosSelecionados(
    catalogosJaSalvos: ICatalogoProdutoEquipeVenda[],
    catalogosSelecionados: ICatalogo[]
  ): ICatalogoProdutoEquipeVenda[] {
    if (catalogosJaSalvos.length > 0 && catalogosSelecionados.length === 0) {
      return [];
    }
    catalogosJaSalvos = [];
    return catalogosSelecionados.map(
      c => ({ catalogo_id: c.id } as ICatalogoProdutoEquipeVenda)
    );
  }
}
